import { gql } from '@apollo/client';

import { FileDocFragment } from '@modules/shared/graphql';

export const LectureSingleFragment = gql`
    fragment LectureSingle on OLLecture {
        id
        userId
        sort
        status
        name
        subjectName
        author
        type
        text
        textType
        createdAt
        updatedAt
        videos {
            ...FileDoc
        }
        docs {
            ...FileDoc
        }
    }
    ${FileDocFragment}
`;
